<app-claim-lead-bar
  *ngIf="(claimRestrictions$ | async)"
  [nextAssignmentExists]="nextAssignmentExists$ | async"
  [claimRestrictions]="claimRestrictions$ | async"
  [flagHighPriority]="flagHighPriority$ | async"
  [loading]="loading$ | async"
  [claimedLead]="claimedLead$ | async"
  [conflict]="conflict$ | async"
  [user]="user"
  (getNext)="getNext()"
  (ackNotAvailable)="ackNotAvailable()"
  (callNow)="callNow($event)"
  (refresh)="refresh()">
</app-claim-lead-bar>
